import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import AuthContextProvider  from './authContext/context';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './redux/store'; // Make sure this path is correct and store.js exists

//import { HelmetProvider } from 'react-helmet-async';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

   <BrowserRouter>
    <Provider store={store}>
     <AuthContextProvider>
   <Toaster/>
   {/* <HelmetProvider>
  <App />
</HelmetProvider> */}

  <App />

   </AuthContextProvider>
   </Provider>
   </BrowserRouter>
  

  </React.StrictMode> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
